import { ReactNode } from "react";
import { ModalBody } from "@ingka/modal";

type FixaModalBodyProps = {
  children: ReactNode;
  className?: string;
};

export const FixaModalBody = (props: FixaModalBodyProps) => {
  const { children, ...rest } = props;
  return <ModalBody {...rest}>{children}</ModalBody>;
};
